import React, { useMemo, useState } from 'react';

import cx from 'classnames';
import { debounce } from 'lodash';

// import { ReactComponent as FilterIcon } from 'pages/Teachers/ClassroomInsights/assets/filter-icon.svg';
import { ReactComponent as SearchIcon } from 'pages/Teachers/ClassroomInsights/assets/search-icon.svg';

import styles from './style.module.scss';

const StudentSearch = ({ students, nameValue = [], onStudentSelect }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState(students);
  const [open, setOpen] = useState(false);
  const [selectedStudents, setSelectedStudents] = useState(nameValue);

  const runSearch = useMemo(
    () =>
      debounce((value) => {
        const v = value.toLowerCase();
        setResults(
          students.filter(
            (s) =>
              s.name.toLowerCase().includes(v) &&
              !selectedStudents.includes(s.name)
          )
        );
        setOpen(true);
      }, 300),
    [students, selectedStudents]
  );

  const onChange = (e) => {
    const value = e.target.value;
    setQuery(value);
    runSearch(value);
  };

  const handleSelect = (student) => {
    const newSelected = [...selectedStudents, student.name];
    setSelectedStudents(newSelected);
    setQuery('');
    setResults([]);
    setOpen(false);
    onStudentSelect(newSelected);
  };

  const handleRemove = (name) => {
    const newSelected = selectedStudents.filter((s) => s !== name);
    setSelectedStudents(newSelected);
    onStudentSelect(newSelected);
  };

  return (
    <div
      className={cx(styles.container, {
        [styles.noOptionsSelected]: selectedStudents.length === 0
      })}
    >
      <div className={styles.searchWrapper}>
        <div className={styles.searchInput}>
          {/* <FilterIcon /> */}
          <input
            type="text"
            placeholder="Search Students here..."
            value={query}
            onChange={onChange}
          />

          <SearchIcon />
        </div>

        {open && (
          <div className={styles.results}>
            {results.length === 0 && (
              <div className={cx(styles.result, styles.empty)}>
                No students found
              </div>
            )}
            {results.map((student, index) => (
              <div
                key={index}
                className={styles.result}
                onClick={() => handleSelect(student)}
              >
                {student.name}
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.selectedContainer}>
        {selectedStudents.map((student) => (
          <div key={student} className={styles.selectedItem}>
            {student}
            <span
              className={styles.removeBtn}
              onClick={() => handleRemove(student)}
            >
              ×
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StudentSearch;
